<template>
  <!--    <VueDocPreview :value="docValue" :type="docType" />-->

  <!--        <iframe  :src='docValue'-->
  <!--                 width='1366px' height='623px'-->
  <!--                frameborder='0' allowfullscreen webkitallowfullscreen>-->
  <!--        </iframe>-->

  <iframe
      className="doc"
      :src="docValue"
      onload="onLoad()"
      onerror="onError()"
      sandbox="allow-same-origin allow-scripts allow-forms"
      style="border: none"
  />
</template>


<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";

import {Mixin} from "/src/mixins/index.js";
import {profilerDocument} from "/src/store/url.js";

Vue.use(VueForm);

export default {
  name: "Viewer",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      module: profilerDocument,
      docType: "office",
      url: "",
      docValue: "",
    };
  },
  created() {
    let self = this;
    self.dismissCountDown = 0;
    const id = this.$route.params.id;
    self.dismissCountDown = 0;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.viewUrlApi(this.module, id)).then((response) => {
      if (response.data) {
        self.url = response.data.docUrl; //&efh=false&a=v
        self.docValue =
            "https://docs.google.com/gview?url=" + self.url + "&embedded=true";
      }
    });
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    const id = this.$route.params.id;
    self.dismissCountDown = 0;

    axios.get(this.viewUrlApi(this.module, id)).then((response) => {
      if (response.data.status === 200) {
        const responseData = response.data.data;
        self.url = responseData.docUrl; //&efh=false&a=v
        self.docValue =
            "https://docs.google.com/gview?embedded=true&url=" + self.url;
      }
    });
  },
  watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1;
    },
  },
  methods: {
    handleDocumentRender() {
      this.isLoading = false;
      this.pageCount = this.$refs.pdfRef.pageCount;
    },
  },
};
</script>
<style>
iframe {
  width: 100%;
  height: 500px;
}

.ndfHFb-c4YZDc-i5oIFb.ndfHFb-c4YZDc-e1YmVc .ndfHFb-c4YZDc-Wrql6b {
  background: rgba(147, 147, 147, 0.7);
}
</style>
